module.exports = __webpack_public_path__ + "media/images/carro-b33cb6419d12d2e8fc9b93b3e2c05b0e.png";